import Modal from 'common/components/feedback/Modal'

interface ModalProps {
  onCancel: () => void
  onOk: () => void
  translate: any
}

const CancelDisclaimerModal = ({ onCancel, onOk, translate }: ModalProps) => {
  return (
    <Modal
      title={translate('admin-dashboard.benefit-details.class-design.cancel-disclaimer-modal.title')}
      closable
      okText={translate('admin-dashboard.benefit-details.class-design.cancel-disclaimer-modal.ok-text')}
      cancelText={translate('admin-dashboard.benefit-details.class-design.cancel-disclaimer-modal.cancel-text')}
      onOk={onOk}
      onCancel={onCancel}
      visible={true}
      destroyOnClose={true}
    >
      <span>{translate('admin-dashboard.benefit-details.class-design.cancel-disclaimer-modal.content')}</span>
    </Modal>
  )
}

export default CancelDisclaimerModal
